import { Alert, AlertTitle, Button } from "@mui/material"
import { useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { applyMappingSettings } from "routes/asset-register/plugins/asset-mapping/controller/apply-mapping-settings"
import { warningSnackbar } from "lib/snackbar/warning-snackbar"
import { errorSnackbar } from "lib/snackbar/error-snackbar"

export function TypeProcessingRetry({ severity, title, message, dataCy }) {
    const { target } = useBoundContext()
    const [retrying, setRetrying] = useState(false)

    return (
        <Alert
            severity={severity}
            data-cy={dataCy}
            action={
                <Button
                    color="inherit"
                    size="small"
                    disabled={retrying}
                    onClick={retry}
                    data-cy="retry-type-processing"
                >
                    Retry
                </Button>
            }
        >
            <AlertTitle>{title}</AlertTitle>
            {message}
        </Alert>
    )

    async function retry() {
        setRetrying(true)
        try {
            const started = await applyMappingSettings(target._id)
            if (!started) warningSnackbar("Asset type processing is already running for this register.")
        } catch (e) {
            console.error("Could not restart asset type processing", target._id, e)
            errorSnackbar("Could not restart asset type processing.")
        } finally {
            setRetrying(false)
        }
    }
}
